import {
  ChakraComponent,
  LinkBox,
  LinkBoxProps,
  useColorModeValue
} from '@chakra-ui/react';

type FigComponent = ChakraComponent<'figure', {}>;

export const Card = ((props: LinkBoxProps) => (
  <LinkBox
    as='figure'
    display='flex'
    cursor='pointer'
    flexDirection='column'
    position='relative'
    borderRadius='5px'
    border='1px solid'
    borderColor={useColorModeValue('#E2E8F0', 'gray.700')}
    bg={useColorModeValue('gray.50', 'gray.900')}
    textDecoration='none'
    p='16px'
    gap={4}
    {...props}
  />
)) as FigComponent;
